export class WebMcpError extends Error {
  constructor(message: string) {
    super(message);
    this.name = this.constructor.name;
  }
}

export class ConsentRequiredError extends WebMcpError {
  constructor(
    message: string,
    readonly toolName: string,
  ) {
    super(`[${toolName}] ${message}`);
  }
}

export class ConsentDeniedError extends WebMcpError {
  constructor(
    message: string,
    readonly toolName: string,
  ) {
    super(`[${toolName}] ${message}`);
  }
}

export class ValidationError extends WebMcpError {
  constructor(
    message: string,
    readonly issues: ReadonlyArray<{ path: ReadonlyArray<PropertyKey>; message: string }> = [],
  ) {
    super(message);
  }
}

export class HandlerError extends WebMcpError {
  constructor(
    message: string,
    override readonly cause: Error,
  ) {
    super(message);
  }
}

export class RegistrationError extends WebMcpError {}
